import { Theme, useMediaQuery } from '@mui/material'
import { Pagination, PaginationContainer } from './styled'
import { useEffect } from 'react'

const BlogPagination = ({
  page,
  totalPages,
  setPage,
}: {
  page: number
  totalPages: number
  setPage: (page: number) => void
}) => {
  const upMd = useMediaQuery<Theme>((theme) => theme.breakpoints.up('md'))
  const handlePageChange = (_: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage)
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [page])

  return (
    <PaginationContainer>
      <Pagination
        count={totalPages}
        page={page}
        onChange={handlePageChange}
        siblingCount={upMd ? 1 : 0}
        boundaryCount={1}
        color="primary"
      />
    </PaginationContainer>
  )
}

export default BlogPagination
